import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNotificationStore } from "@/store/notificationStore";
import { CrossCircled, InfoCircleIcon } from "@/assets/icons";
import cls from "./styles.module.scss";

const Notification: React.FC = () => {
  const { notifications } = useNotificationStore();

  return (
    <div className={cls.notificationContainer}>
      <AnimatePresence>
        {notifications.map((notif) => (
          <motion.div
            key={notif.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className={cls.notification}
            data-type={notif.type}
          >
            {notif.type === "error" ? <CrossCircled /> : <InfoCircleIcon />}
            {notif.message}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default Notification;
